import { Button, ButtonProps, Link } from '@mui/material'
import { ReactNode } from 'react'
import { Link as RouterLink } from 'react-router-dom'

interface NextButtonProps extends ButtonProps {
  children: ReactNode
  to: string
  state?: string
}

export const NextButton = ({
  children,
  to,
  state,
  ...rest
}: NextButtonProps) => {
  return (
    <Link component={RouterLink} to={to} state={state ? state : null}>
      <Button
        {...rest}
        sx={{
          backgroundColor: (theme) => theme.palette.secondary.main,
          color: (theme) => theme.palette.primary.contrastText,
        }}
      >
        {children}
      </Button>
    </Link>
  )
}
